define('lq/uploader',[
    'jquery',
    'lq',
    'lq/fileUpload'
], function ($, lq, FileUpload) {

    function Uploader(piping) {
        this.piping = piping;
        this.targetDiv = $('<div />')
            .hide()
            .appendTo($('body'));
        this.onStartingUploadCallback = $.noop;
        this.onFileUploadedCallback = $.noop;
        this.onUploadFinishedCallback = $.noop;
    };

    Uploader.prototype.withParameters = function (params) {
        this.params = params;
        return this;
    };

    Uploader.prototype.toTenantUrl = function (path) {
        this.url = lq.getTenantUrl(path);
        return this;
    };

    Uploader.prototype.withFileFilter = function (filter) {
        this.filter = filter;
        return this;
    };

    Uploader.prototype.withMaxFileSize = function (maxFileSizeInKb) {
        this.maxFileSizeInKb = maxFileSizeInKb;
        return this;
    };

    Uploader.prototype.withSmartphoneMode = function (mode) {
        this.smartphoneMode = mode;
        return this;
    };

    Uploader.prototype.withPhotoQuality = function (value) {
        this.photoQuality = value;
        return this;
    };

    Uploader.prototype.withMaxImageDimensions = function (maxImageDimensions) {
        this.maxImageDimensions = maxImageDimensions;
        return this;
    };

    Uploader.prototype.onMaxFileSizeExceeded = function (onMaxFileSizeExceededCallback) {
        this.onMaxFileSizeExceededCallback = onMaxFileSizeExceededCallback;
        return this;
    };

    Uploader.prototype.onStartingUpload = function (onStartingUploadCallback) {
        this.onStartingUploadCallback = onStartingUploadCallback;
        return this;
    };

    Uploader.prototype.onFileUploaded = function (onFileUploadedCallback) {
        this.onFileUploadedCallback = onFileUploadedCallback;
        return this;
    };

    Uploader.prototype.onUploadFinished = function (onUploadFinishedCallback) {
        this.onUploadFinishedCallback = onUploadFinishedCallback;
        return this;
    };

    Uploader.prototype.uploadSingleFile = function () {
        this._doUpload(false);
    };

    Uploader.prototype.uploadMultipleFiles = function () {
        this._doUpload(true);
    };

    Uploader.prototype._doUpload = function (allowMultipleUploads) {
        if (navigator.camera)
            this._doSmartphoneUpload(allowMultipleUploads);
        else
            this._doNormalUpload(allowMultipleUploads);
    };

    Uploader.prototype._doSmartphoneUpload = function (allowMultipleUploads) {
        if (!navigator.camera) return;

        var self = this;
        var counter = 0;
        this.piping.busyIndicator.showWithCount(counter);
        this.piping.busyIndicator.showText('Uploading...');

        self.onStartingUploadCallback();

        var sourceType = (this.smartphoneMode === 'PHOTOLIBRARY')
            ? Camera.PictureSourceType.PHOTOLIBRARY
            : Camera.PictureSourceType.CAMERA;

        navigator.camera.getPicture(
            function onSuccess(imageUrl) {
                uploadSmartphoneFile(imageUrl);
            }, function onFail(message) {
                //alert('Failed launching Photo App: ' + message);
                self.piping.busyIndicator.forceHide();
            }, {
                destinationType: Camera.DestinationType.FILE_URI,
                sourceType: sourceType,
                encodingType: Camera.EncodingType.JPEG,
                quality: self.photoQuality || 50,
                correctOrientation: true
            });

        function uploadSmartphoneFile(imageURI) {
            var options = new FileUploadOptions();
            options.fileKey = "file";
            // always assuming jpg for now. note that on Android we can't ask for the original name of the file
            options.fileName = new Date().valueOf() + ".jpg";
            options.mimeType = "text/plain";
            options.httpMethod = "POST";

            var uri = encodeURI(location.protocol + "//" + location.host + self.url + "Smartphone"); //DynamicContentController/AddTempFileSmartphone

            self.onStartingUploadCallback();

            var ft = new FileTransfer();
            ft.upload(imageURI, uri,
                function win(r) {
                    self.onFileUploadedCallback(JSON.parse(r.response));
                    self.onUploadFinishedCallback();
                }, function fail(error) {
                    //alert(JSON.stringify(error));
                    self.piping.busyIndicator.forceHide();
                }, options);
        };
    };

    Uploader.prototype._doNormalUpload = function (allowMultipleUploads) {
        var self = this;

        var counter = 0;

        var filesText = '';
        var percentageText = '';

        var upload = new FileUpload({
            action: this.url,
            params: this.params,
            maxFileSizeInKb: this.maxFileSizeInKb,
            maxImageDimensions: this.maxImageDimensions,
            accept: this.filter,
            multiple: allowMultipleUploads,
            onMaxFileSizeExceeded: function (filename) {
                if (!self.onMaxFileSizeExceededCallback) {
                    alert(filename + ' is too large, maximum file size is  ' + self.maxFileSizeInKb + 'KB');
                } else {
                    self.onMaxFileSizeExceededCallback();
                }
            },
            onStart: function () {
                self.piping.busyIndicator.showWithCount(counter);
                self.piping.busyIndicator.showText('Uploading...');

                self.onStartingUploadCallback(upload);
            },
            onUploadingFile: function (total, uploaded) {
                filesText = ' (' + (uploaded + 1) + '/' + total + ')...';
                self.piping.busyIndicator.showText('Uploading' + filesText + percentageText);
            },
            onFileUploading: function (percentage) {
                percentageText = '  ' + percentage + '%';
                self.piping.busyIndicator.showText('Uploading' + filesText + percentageText);
            },
            onFileUploaded: function (response) {
                self.onFileUploadedCallback(response);
            },
            onFinished: function () {
                self.piping.busyIndicator.showText('');

                self.onUploadFinishedCallback();
            }
        });

        counter = this.piping.busyIndicator.forceHide();

        upload.do();
    };

    return Uploader;
});
